module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-DB_1.a6305eea.jpg";